import EditorContentContainer from './Editor.Content.Container';
import EditorContentImage from './Editor.Content.Image';
import EditorContentLauncher from './Editor.Content.Launcher';
import EditorContentParagraph from './Editor.Content.Paragraph';
import EditorContentQR from './Editor.Content.QR';

const editorResolvers = {
  EditorContentContainer,
  EditorContentParagraph,
  EditorContentImage,
  EditorContentQR,
  EditorContentLauncher,
};

export default editorResolvers;
